<div class="add-Supplier-Responsive p-g-12">
   <app-confirm-dialog
      [visible]="confirmationDialogVisible"
      variant="secondary"
      heading="Confirmation"
      [message]="confirmationDialogMessage"
      cancelText="No"
      (confirmed)="confirmConfirmationDialog()"
      (cancelled)="cancelConfirmationDialog()">
   </app-confirm-dialog>
   <div class="p-g-12">

      <p-tabView>

         <div class="p-g">

            <div class="p-g-12">
               <form>
                  <div class="p-g-12">
                     <p-toolbar>
                        <div class="p-toolbar-group-left">
                           <button routerLink="/suppliers-listing" style="background-color: #405569; margin-right: 8px;"
                              class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                 class="fa fa-arrow-left" style="margin-right: 8px;"></i>{{setLabel("goBackBtnLabel")}}
                           </button>

                           <button routerLink="/supplier" *ngIf="mode == 'edit'"
                              style="background-color: #5192d0; margin-right: 8px;"
                              class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                              <i class="fa fa-plus" style="margin-right: 8px;"></i>
                              {{setLabel("newBtnLabel")}}
                           </button>

                           <button id="saveButton" style="background: #4CAF50; color: white; margin-right: 8px;"
                              [disabled]="!addEditSupplierForm.valid"
                              class="p-button p-widget p-state-default p-corner-all p-button-text-only" (click)="save()"
                              *ngIf="mode == 'add'">
                              <i class="fa fa-floppy-o" style="margin-right: 8px;"></i> {{setLabel("saveBtnLabel")}}
                           </button>

                           <button id="updateButton" style="background: #4CAF50; color: white; margin-right: 8px;"
                              [disabled]="!addEditSupplierForm.valid"
                              class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                              (click)="update()" *ngIf="mode == 'edit'">
                              <i class="fa fa-floppy-o" style="margin-right: 8px;"></i> {{setLabel("updateBtnLabel")}}
                           </button>

                        </div>
                     </p-toolbar>
                  </div>

                  <p-tabView>

                     <div class="card card-w-title">

                        <div class="profileImgContainer">
                           <div class="p-g-12 p-md-4 imgstyle">
                              <img style="width:50%;"
                                 [src]="Supplier.profile == null || Supplier.profile == undefined || Supplier.profile == '' ? 'assets/layout/images/avatarBoyImage.png' : Supplier.profile"
                                 (error)="onImgError($event)" />
                           </div>
                           <div class="userDetailToolBar">
                              <h3 class="first">{{setLabel("profilePictureBtnLabel")}}</h3>
                              <button (click)="captureImageDialogShow('Cam')" class="">
                                 <span class="p-button-text p-c">
                                    <i class="fa fa-camera" aria-hidden="true"></i>
                                    &nbsp;{{setLabel("capturePhotoBtnLabel")}}
                                 </span>
                              </button>
                              <button (click)="captureImageDialogShow('Upload')" class="">
                                 <span class="p-button-text p-c">
                                    <i class="fa fa-upload" aria-hidden="true"></i>
                                    &nbsp;{{setLabel("uploadPhotoBtnLabel")}}
                                 </span>
                              </button>
                              <button (click)="removeProfileImage()" class="removePhoto">
                                 <span class="p-button-text p-c">
                                    <i class="fa fa-times"></i> &nbsp;{{setLabel("removePhotoBtnLabel")}}
                                 </span>
                              </button>

                           </div>
                        </div>

                        <div class="p-g-12">
                           <form class="add-Supplier-Form" #addEditSupplierForm="ngForm">

                              <div class="p-g-12 p-md-6" style="text-align: left">

                                 <div class="p-g p-fluid">

                                    <h3 class="first">{{setLabel("supplierDetailsLabel")}} </h3>

                                    <div class="p-g-12">

                                       <div class="p-inputgroup">
                                          <span class="p-inputgroup-addon" [pTooltip]='setLabel("nameTooltipLabel")'
                                             tooltipPosition="top"><i class="fa fa-user" aria-hidden="true"></i></span>
                                          <input autocomplete="off" id="supplierName" #supplierName pattern="[A-Za-z ]+"
                                             [ngClass]="Name.invalid && (Name.dirty || Name.touched) ? 'errorInput' : ''"
                                             type="text" autofocus [placeholder]='setLabel("nameplaceholderLabel")'
                                             #Name="ngModel" name="name" required [(ngModel)]="Supplier.name" />
                                       </div>
                                       <div *ngIf="Name.invalid &&
                                                                         (Name.dirty ||
                                                                         Name.touched)">
                                          <div *ngIf="Name.errors.required" class="errorShow">
                                             {{setLabel("nameErrorLabel")}}
                                          </div>
                                          <div *ngIf="Name.errors.pattern" class="errorShow">
                                             {{setLabel("onlyCharactersErrorLabel")}}
                                          </div>
                                       </div>

                                    </div>

                                    <div class="p-g-12">
                                       <app-phone-input
                                          id="supplierNumber"
                                          name="contact"
                                          [placeholder]="setLabel('mobileNumberplaceholderLabel')"
                                          [(ngModel)]="Supplier.phone"
                                          [required]="true">
                                       </app-phone-input>
                                    </div>

                                    <div class="p-g-12">
                                       <div class="p-inputgroup">
                                          <span class="p-inputgroup-addon" [pTooltip]='setLabel("emailTooltipLabel")'
                                             tooltipPosition="top"><i class="fa fa-envelope"
                                                aria-hidden="true"></i></span>
                                          <input type="email" id="supplierMail" autocomplete="off"
                                             [placeholder]='setLabel("emailplaceholderLabel")' name="email"
                                             #email="ngModel" [(ngModel)]="Supplier.email"
                                             pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                                       </div>
                                       <div *ngIf="email.invalid && (email.dirty || email.touched)">
                                          <div *ngIf="email.errors.required" class="errorShow">
                                             {{setLabel("emailErrorLabel")}}
                                          </div>
                                          <div *ngIf="email.errors.pattern" class="errorShow">
                                             {{setLabel("emailCorrectlyErrorLabel")}}
                                          </div>
                                       </div>
                                    </div>
                                 </div>

                              </div>

                              <div class="p-g-12 p-md-6" style="text-align: left">
                                 <h3 class="first">{{setLabel("createdDateLabel")}}</h3>
                                 <div class="p-g p-fluid">
                                    <div class="p-g-12">
                                       <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                                          [(ngModel)]="Supplier.createdDate"
                                          [placeholder]='setLabel("joiningDatePlaceholderLabel")' [disabled]="true"
                                          name="joinDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                                       </p-calendar>
                                    </div>
                                 </div>

                                 <div class="p-g-12">
                                    <div class="p-g">
                                       <h3 class="first">{{setLabel("genderLabel")}}</h3>
                                       <div class="p-g-12">
                                          <div class="p-g-6">
                                             <p-radioButton name="group1" id="supplierGender"
                                                [value]='setLabel("maleLabel")' [label]='setLabel("maleLabel")'
                                                (change)="changeProfile()" (ngModelChange)="changeProfile()"
                                                [(ngModel)]="Supplier.gender" inputId="opt1">
                                             </p-radioButton>
                                          </div>
                                          <div class="p-g-6">
                                             <p-radioButton name="group1" [value]='setLabel("femaleLabel")'
                                                [label]='setLabel("femaleLabel")' (change)="changeProfile()"
                                                (ngModelChange)="changeProfile()" [(ngModel)]="Supplier.gender"
                                                inputId="opt2">
                                             </p-radioButton>
                                          </div>
                                       </div>
                                    </div>
                                 </div>

                              </div>
                           </form>
                        </div>
                        <div style="clear: both;"></div>
                     </div>

                  </p-tabView>
               </form>
            </div>
         </div>
      </p-tabView>
   </div>

   <div *ngIf="dialogVisibility">
      <p-dialog header="Add Product Image" [(visible)]="dialogVisibility">
         <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
            (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
      </p-dialog>
   </div>
</div>